import {Group, Stack, Text} from '@mantine/core';
import React from 'react';

export interface ListGroup<T> {
  /** Stable group key, unique within the list. */
  key: string;
  label: string;
  items: T[];
}

export interface GroupedListProps<T> {
  groups: ListGroup<T>[];
  getItemKey: (item: T) => React.Key;
  renderItem: (item: T) => React.ReactNode;
}

/**
 * Grouped list shell: bold group label with a dimmed item count, then the items via `renderItem`.
 * @registry Labeled item groups with counts; caller renders each item.
 */
export function GroupedList<T>({
  groups,
  getItemKey,
  renderItem,
}: GroupedListProps<T>) {
  return (
    <Stack gap="lg">
      {groups.map(group => (
        <Stack key={group.key} gap="xs">
          <Group gap="xs">
            <Text fw={700} size="sm">
              {group.label}
            </Text>
            <Text size="xs" c="dimmed">
              · {group.items.length}
            </Text>
          </Group>
          <Stack gap="xs">
            {group.items.map(item => (
              <React.Fragment key={getItemKey(item)}>
                {renderItem(item)}
              </React.Fragment>
            ))}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
